import { Component, OnInit, ViewChild, ElementRef, Renderer, Input, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
import { FormGroup, FormControl } from '@angular/forms';
import { CurrencyPipe, UpperCasePipe, LowerCasePipe } from '@angular/common';
import { Helper } from '../../../helpers/helper';
import * as jsPDF from 'jspdf';
declare const CKEDITOR: any;
declare const $: any;

@Component({
  selector: 'app-pagare-notarial-modal',
  templateUrl: './pagare-notarial-modal.component.html',
  styleUrls: ['./pagare-notarial-modal.component.css']
})
export class PagareNotarialModalComponent implements OnInit, AfterViewInit {
  @ViewChild('pdf') pdf: ElementRef;
  @ViewChild('bodyPdf') bodyPdf: ElementRef;
  @ViewChild('headerPdf') headerPdf: ElementRef;
  @ViewChild('footerPdf') footerPdf: ElementRef;
  @ViewChild('ckeditor') ckeditor: ElementRef;
  @Input() datos: any;
  isEditing = false;
  form: FormGroup;
  ckeditorHasError =  false;
  showAtajos = false;
  pdfContent: string;
  private comandos: Array<any> = [];
  exportando = false;
  doc: any = new jsPDF('p', 'pt', 'legal');
  pageWidth: number = this.doc.internal.pageSize.getWidth();
  pageHeight: number = this.doc.internal.pageSize.getHeight();
  formAux: any;
  // tslint:disable-next-line:max-line-length
  constructor(public activeModal: NgbActiveModal, private render: Renderer, private configuracionesService: ConfiguracionesService, private helper: Helper) {
    this.initForm();
  }

  ngOnInit() {
    this.initCommands();
    this.initPagare();
  }

  private initCommands() {
    const comandos = {
      notario: 'Atajo para insertar el nombre del notario.',
      cedulaNotario: 'Atajo para insertar la cédula del notario.',
      direccionNotario: 'Atajo para insertar el nombre del notario.',
      matriculaNotario: 'Atajo para insertar el nombre del notario.',
      empresa: 'Atajo para insertar el nombre de la empresa.',
      rncEmpresa: 'Atajo para insertar el rnc de la empresa.',
      direccionEmpresa: 'Atajo para insertar el rnc de la empresa.',
      acreedor: 'Atajo para insertar el nombre del acreedor.',
      cedulaAcreedor: 'Atajo para insertar la cédula del acreedor.',
      direccionAcreedor: 'Atajo para insertar la dirección del acreedor.',
      testigo1: 'Atajo para insertar el nombre del testigo 1.',
      cedulaTestigo1: 'Atajo para insertar la cédula del testigo 1.',
      testigo2: 'Atajo para insertar el nombre del testigo 2.',
      cedulaTestigo2: 'Atajo para insertar la cédula del testigo 2.',
      cliente: 'Atajo para insertar el nombre completo del cliente.',
      cedulaCliente: 'Atajo para insertar la cédula del cliente.',
      direccionCliente: 'Atajo para insertar la dirección del cliente.',
      montoPrestamo: 'Atajo para insertar el capital + interes del préstamo.',
      totalCuotas: 'Atajo para insertar el total de cuotas del préstamo.',
      montoCuota: 'Atajo para insertar el monto de cuota del préstamo.',
      primeraFechaPago: 'Atajo para insertar la fecha del primer pago de la cuota.',
      ultimaFechaPago: 'Atajo para insertar la fecha del último pago de la cuota.',
      formaPago: 'Atajo para insertar la forma de pago del préstamo (SEMANAL, QUINCENAL, etc).',
      plazo: 'Atajo para insertar el plazo del préstamo (QUINCE (15) días, etc).',
      fechaPrestamo: 'Atajo para insertar la fecha del préstamo.'
    };

    // tslint:disable-next-line:forin
    for (const k in comandos) {
      this.comandos.push({
        key: `#${k}#`,
        value: comandos[k]
      });
    }
  }

  private initCkeditor() {
    CKEDITOR.replace('editor1', {
      height: 1390
    });
  }

  private initForm(): void {
    this.form = new FormGroup({
      notario: new FormControl(''),
      cedulaNotario: new FormControl(''),
      direccionNotario: new FormControl(''),
      matriculaNotario: new FormControl(''),
      empresa: new FormControl(''),
      rncEmpresa: new FormControl(''),
      direccionEmpresa: new FormControl(''),
      acreedor: new FormControl(''),
      cedulaAcreedor: new FormControl(''),
      direccionAcreedor: new FormControl(''),
      testigo1: new FormControl(''),
      cedulaTestigo1: new FormControl(''),
      testigo2: new FormControl(''),
      cedulaTestigo2: new FormControl(''),
      cliente: new FormControl(''),
      cedulaCliente: new FormControl(''),
      direccionCliente: new FormControl(''),
      montoPrestamo: new FormControl(''),
      totalCuotas: new FormControl(''),
      montoCuota: new FormControl(''),
      primeraFechaPago: new FormControl(''),
      ultimaFechaPago: new FormControl(''),
      formaPago: new FormControl(''),
      plazo: new FormControl(''),
      fechaPrestamo: new FormControl(''),
      pagare_html: new FormControl('')
    });
  }

  private initPagare() {
    this.configuracionesService.pagareNotarial()
    .subscribe((res: any) => {
      const form = this.form;
      if (res) {
        form.get('notario').setValue(res.notario);
        form.get('cedulaNotario').setValue(res.cedulaNotario);
        form.get('direccionNotario').setValue(res.direccionNotario);
        form.get('matriculaNotario').setValue(res.matriculaNotario);
        form.get('empresa').setValue(res.empresa);
        form.get('rncEmpresa').setValue(res.rncEmpresa);
        form.get('direccionEmpresa').setValue(res.direccionEmpresa);
        form.get('acreedor').setValue(res.acreedor);
        form.get('cedulaAcreedor').setValue(res.cedulaAcreedor);
        form.get('direccionAcreedor').setValue(res.direccionAcreedor);
        form.get('testigo1').setValue(res.testigo1);
        form.get('cedulaTestigo1').setValue(res.cedulaTestigo1);
        form.get('testigo2').setValue(res.testigo2);
        form.get('cedulaTestigo2').setValue(res.cedulaTestigo2);
        form.get('pagare_html').setValue(res.pagare_html);

        if (this.datos) {
          this.setForm();
        }
        this.formAux = this.form.value;

        const maxHeight = this.pageHeight;
        this.render.setElementStyle(this.pdf.nativeElement, 'word-wrap', 'break-word');
        this.render.setElementStyle(this.pdf.nativeElement, 'height', `${this.pageHeight}pt`);
        this.render.setElementStyle(this.pdf.nativeElement, 'width', `${this.pageWidth}pt`);
        this.render.setElementStyle(this.ckeditor.nativeElement, 'width', `${this.pageWidth}pt`);
        this.render.setElementStyle(this.bodyPdf.nativeElement, 'max-height', `${maxHeight}pt`);
        this.render.setElementStyle(this.bodyPdf.nativeElement, 'overflow', 'hidden');
        // this.render.setElementStyle(this.bodyPdf.nativeElement, 'padding-right', '-10px');

        this.pdfContent = this.restoreCkeditorContent(res.pagare_html);
        this.initCkeditor();
      } else {
        this.initCkeditor();
      }
    });
  }

  guardarPagare() {
    const ckeditorValue = CKEDITOR.instances.editor1.getData();
    if (!ckeditorValue) {
      this.ckeditorHasError = true;
      return false;
    }
    this.pdfContent = this.restoreCkeditorContent(ckeditorValue);
    this.isEditing = false;
  }

  private restoreCkeditorContent(ckeditorValue): string {
    let pdfContent = ckeditorValue;

    if (pdfContent) {
      // tslint:disable-next-line:forin
      for (const row of this.comandos) {
        const regExp = new RegExp(row.key, 'g');

        for (const keyForm of Object.keys(this.form.controls)) {
          if (row.key === `#${keyForm}#`) {

            pdfContent = pdfContent.replace(regExp, this.form.get(keyForm).value || this.formAux[keyForm]);
          }
        }
      }
    }

    return pdfContent;
  }

  private setForm() {
    const currencyPipe = new CurrencyPipe('en-US');
    const uppercasePipe = new UpperCasePipe();
    const lowercasePipe = new LowerCasePipe();

    this.form.get('cliente').setValue(this.datos.nombreCliente);
    this.form.get('cedulaCliente').setValue(this.datos.cedula);
    this.form.get('direccionCliente').setValue(this.datos.direccion);

    // tslint:disable-next-line:max-line-length
    const montoPrestamo = uppercasePipe.transform(this.helper.numeroALetra(this.datos.capital + this.datos.totalInteres, {})) + ` (${currencyPipe.transform(this.datos.capital + this.datos.totalInteres, 'RD$ ', 'symbol', '1.0-2')})`;
    this.form.get('montoPrestamo').setValue( montoPrestamo );

    switch (this.datos.formaPago) {
      case 1:  this.form.get('formaPago').setValue('diario');      break;
      case 2:  this.form.get('formaPago').setValue('interdiario'); break;
      case 7:  this.form.get('formaPago').setValue('semanal');     break;
      case 15: this.form.get('formaPago').setValue('quincenal');   break;
      case 30: this.form.get('formaPago').setValue('mensual');     break;
      default: this.form.get('formaPago').setValue(`${this.datos.formaPago} dias`); break;
    }

    this.form.get('totalCuotas').setValue(this.datos.cuotas.length);

    // tslint:disable-next-line:max-line-length
    const montoCuota = uppercasePipe.transform(this.helper.numeroALetra(this.datos.cuotas[0].monto_cuota, {})) + ` (${currencyPipe.transform(this.datos.cuotas[0].monto_cuota, 'RD$ ', 'symbol', '1.0-2')})`;
    this.form.get('montoCuota').setValue(montoCuota);

    // tslint:disable-next-line:max-line-length
    this.form.get('plazo').setValue( lowercasePipe.transform(this.helper.numeroALetra(this.datos.formaPago, {}, false)) + ` (${this.datos.formaPago}) dias`);

    // Martes 25 del mes de Abril
    const fechaInicio = new Date(this.datos.fecha_inicio);
    // tslint:disable-next-line:max-line-length
    const primeraFechaPago = `${this.helper.dayNames[fechaInicio.getDay()]} ${fechaInicio.getDate()} del mes de ${this.helper.fullMonthNames[fechaInicio.getMonth()]} del año ${fechaInicio.getFullYear()}`;
    this.form.get('primeraFechaPago').setValue(primeraFechaPago);

    const fechaTermina = new Date(this.datos.fecha_vence);
    // tslint:disable-next-line:max-line-length
    const ultimaFechaPago = `${this.helper.dayNames[fechaTermina.getDay()]} ${fechaTermina.getDate()} del mes de ${this.helper.fullMonthNames[fechaTermina.getMonth()]} del año ${fechaTermina.getFullYear()}`;
    this.form.get('ultimaFechaPago').setValue(ultimaFechaPago);

    let fechaPrestamo: string | Date = new Date(this.datos.fecha_prestamo);
    // tslint:disable-next-line:max-line-length
    fechaPrestamo = lowercasePipe.transform(this.helper.numeroALetra(fechaPrestamo.getDate(), {}, false)) + ` (${fechaPrestamo.getDate()}) ${fechaPrestamo.getDate() > 1 ? 'dias' : 'día'} del mes de ${this.helper.fullMonthNames[fechaPrestamo.getMonth()]} del año ${lowercasePipe.transform(this.helper.numeroALetra(fechaPrestamo.getFullYear(), {}, false))} (${fechaPrestamo.getFullYear()})`;
    this.form.get('fechaPrestamo').setValue(fechaPrestamo);
  }

  printPagareNotarial() {
    this.exportando = true;

    setTimeout(() => {

      const pdfName = `pagare_notarial.pdf`.toLowerCase();
      this.helper.exportarPagareNotarialPdf(pdfName, this.pdf, this.doc)
      .then(() => {
        this.exportando = false;
      });
    }, 0);
  }

  fullScreen() {
    const modalRef = $('.modal-dialog');
    if (modalRef.hasClass('full-screen')) {
      modalRef.removeClass('full-screen');
    } else {
      modalRef.addClass('full-screen');
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.fullScreen();
    }, 0);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/pagare-notarial-modal/pagare-notarial-modal.component.ts